import NextImage from 'next/legacy/image';
import { Image as DatoImage } from 'react-datocms';
import { Band } from '@/components/Modules/Band/Band';
import type { MediaFeaturedFragment } from '@/utils/dato/generated';

const MediaFeatured = ({ images, title }: MediaFeaturedFragment) => (
  <Band contained>
    <div className="py-8 bg-base-100 sm:rounded-lg">
      {title ? (
        <div className="text-center">
          <h3 className="text-base lg:text-lg font-serif font-semibold mb-6 uppercase">{title}</h3>
        </div>
      ) : null}

      {images ? (
        <ul className="p-0 m-0 w-full lg:flex lg:flex-wrap lg:justify-center lg:items-center lg:gap-8">
          {images.map(({ imageFile }, index) => {
            const imageAlt = imageFile?.title || `FÛeatured media ${index + 1}`;

            return (
              <li className="list-none text-center py-5 px-2 leading-[0] align-middle lg:py-0" key={`image-${index}`}>
                <div className="max-w-[240px] mx-auto max-h-[80px] flex items-center justify-center [&_img]:max-h-[80px] [&_img]:w-auto [&_img]:object-contain">
                  {imageFile?.responsiveImage ? (
                    <DatoImage data={imageFile.responsiveImage} className="mx-auto" />
                  ) : imageFile?.url ? (
                    <NextImage
                      height={imageFile.height || undefined}
                      width={imageFile.width || undefined}
                      src={imageFile.url}
                      objectFit="contain"
                      alt={imageAlt}
                    />
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  </Band>
);

export default MediaFeatured;
